module.exports = __webpack_public_path__ + "static/media/rubric-desktop.822078c3.jpg";